<template>
  <div class="irp-data-source-cell">
    <template v-if="integrationType">
      <BittsSvg
        :svg="`${integrationType}Icon`"
        class="irp-data-source-cell__icon"
      />
      <span class="irp-data-source-cell__label">{{ label }}</span>
    </template>
    <span v-else class="irp-data-source-cell__empty">&mdash;</span>
  </div>
</template>

<script setup lang="ts">
import { BittsSvg } from '@crossbeam/bitts';

import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import { DataSourceFriendlyName } from '@/constants/data_sources';
import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const integrationType = computed(
  () => params.data?.data_source?.integration_type ?? '',
);

const label = computed(
  () =>
    params.data?.data_source?.label ||
    DataSourceFriendlyName[integrationType.value] ||
    integrationType.value,
);
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-data-source-cell {
  @apply flex items-center gap-8 h-full w-full text-neutral-text;
}

.irp-data-source-cell__icon {
  @apply h-16 w-16 shrink-0;
}

.irp-data-source-cell__label {
  @apply truncate text-sm;
}

.irp-data-source-cell__empty {
  @apply text-neutral-text-weak;
}
</style>
